// extracted by mini-css-extract-plugin
export var messageSideLeft = "_kg-1";
export var messageSideRight = "_kg-2";
export var subscribeToBackInStockBubbleContainer = "_kg-0";